import React from "react";
import AnswerFeedback from './AnswerFeedback';
class Answer extends React.Component {
  clicked() {
    this.props.onClick();
  }

  isSelected() {
    return this.props.selectedAnswer === this.props.choice;
  }

  render() {
    return (
      <div className='radio'>
        <p className='answer' onClick={() => this.clicked()}>
          {this.isSelected()
            ? <AnswerFeedback didAnswerCorrectly={this.props.isCorrect}/>
            : null
          }
          <span><input type='radio' name={this.props.questionId} onChange={() => this.clicked()} checked={this.isSelected()} /></span>
          {`${this.props.choice}) ${this.props.answerText}`}
        </p>
      </div>
    );
  }
}
export default Answer
